var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 130,
    viewBox: "0 0 235 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 626598"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M147.055 75.6593V49.1943L142.486 61.3871C132.909 57.5434 123.837 52.6898 114.541 47.9971C110.98 46.2013 109.027 46.2344 106.16 45.004C104.834 50.3302 96.8658 49.07 85.93 44.626C80.9151 45.8284 76.2529 48.1924 72.3194 51.5274C67.8539 55.6315 63.3088 69.8008 59.7171 80.4482C52.274 72.984 45.2111 65.1501 38.5551 56.9763C27.4037 59.8864 24.5914 68.2786 23.7158 69.3282L27.3075 73.7076C35.4327 83.5374 43.1168 92.5381 49.8972 98.3451C60.2991 107.253 70.313 105.807 74.4718 92.9576L78.158 80.9539C78.0889 85.2093 77.7944 89.458 77.2758 93.6823C89.185 96.8959 99.7395 97.9936 109.506 96.7068C111.994 84.136 115.618 81.9306 116.847 71.9117L141.201 81.9936C144.408 83.3055 147.997 83.3281 151.22 82.0566C149.98 81.5097 148.925 80.6135 148.186 79.4776C147.446 78.3416 147.053 77.0148 147.055 75.6593Z",
    fill: "#3FC8D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M166.213 106.253H177.461L180.044 82.6572H177.713L175.759 101.624C175.679 102.353 175.333 103.027 174.786 103.517C174.239 104.007 173.531 104.277 172.798 104.277H168.198C167.937 104.275 167.679 104.324 167.438 104.423C167.197 104.522 166.979 104.668 166.795 104.852C166.61 105.035 166.463 105.254 166.363 105.494C166.263 105.735 166.212 105.993 166.213 106.253Z",
    fill: "#3FC8D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M151.978 82.6231H154.299C152.662 82.6209 151.093 81.9696 149.935 80.812C148.778 79.6544 148.126 78.085 148.124 76.4479V31.6764C148.128 30.0399 148.78 28.4714 149.937 27.3144C151.094 26.1573 152.663 25.506 154.299 25.5029H151.978C150.341 25.5056 148.772 26.1568 147.615 27.3139C146.457 28.471 145.806 30.0398 145.803 31.6764V76.4479C145.805 78.085 146.456 79.6544 147.614 80.812C148.771 81.9696 150.341 82.6209 151.978 82.6231Z",
    fill: "#3FC8D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M45.8271 106.271V108.27C45.8271 111.655 46.6596 114.988 48.2531 117.974H231.365C232.958 115.022 233.792 111.72 233.791 108.365V106.271H45.8271Z",
    fill: "#3FC8D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M99.8939 38.7058C99.532 37.3595 99.3519 35.9709 99.3583 34.5768C98.1247 34.1271 96.9245 33.5907 95.7666 32.9717L99.8939 38.7058Z",
    fill: "#3FC8D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M117.322 64.1309C117.336 66.7306 117.199 69.3289 116.912 71.9128L127.372 76.2606C120.907 72.5728 117.322 64.1624 117.322 64.1309Z",
    fill: "#3FC8D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M56.0652 76.7644L49.9298 46.8968C49.7485 46.0253 49.7584 45.1249 49.9586 44.2576C50.1589 43.3902 50.5449 42.5767 51.0899 41.8729C51.635 41.1691 52.3261 40.5919 53.1158 40.181C53.9054 39.7702 54.7748 39.5354 55.6639 39.4929L92.4943 37.6357",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M99.5791 37.2873L101.469 37.1629C103.298 37.072 105.099 37.6288 106.557 38.7353C108.015 39.8417 109.036 41.427 109.44 43.2121C109.656 44.1572 109.882 45.2019 110.134 46.2996",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M123.682 106.09C123.525 105.554 120.277 90.9752 116.527 74.4346",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M160.885 25.5036C161.231 25.157 166.179 21.7594 167.849 20.8407C170.184 19.5556 172.764 18.1876 175.311 16.934C177.548 15.8313 187.726 10.8931 189.961 10.2862C196.047 8.62804 196.034 10.2713 191.033 13.1848C187.619 15.163 184.447 17.5319 181.581 20.2438C179.948 21.9051 178.402 23.6503 176.949 25.4721",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M161.431 25.0959L166.283 18.8262C169.073 14.946 171.677 10.6861 171.891 10.2566C175.514 4.428 175.313 7.20052 175.041 9.65798C174.844 11.4538 172.206 17.881 175.293 16.9358",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M177.554 25.5055C180.58 23.3495 183.737 21.3819 187.005 19.6139C189.181 18.3554 192.653 16.9824 195.102 15.6442C195.671 15.3325 195.734 14.2016 191.794 14.9809C190.345 15.2661 187.825 15.7686 186.596 16.1417",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M178.561 25.4721C180.09 24.6331 181.668 23.8867 183.286 23.2368C185.492 22.3845 189.53 21.4858 191.919 20.6218C192.519 20.4046 192.771 19.3616 188.768 19.4246C188.453 19.4246 187.886 19.4561 187.193 19.4876",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M25.7881 65.9291C23.5613 63.385 21.0922 61.0637 18.4157 58.9979C15.9643 57.2104 13.3228 55.6995 10.5393 54.4925C6.44517 52.7216 6.22795 51.9936 11.0749 52.1611C12.942 52.2042 14.7992 52.4363 16.6199 52.8542C22.5793 54.0802 28.3667 56.0291 33.8536 58.6579",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M21.189 53.9853C24.4656 54.5524 20.8375 48.9162 19.8973 46.079C19.1047 43.6845 19.1163 40.9684 23.489 46.394C27.116 50.4797 30.999 54.3306 35.1146 57.9235",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M11.8937 55.0875C9.59125 54.6115 7.25 54.3479 4.89938 54.2998C0.394044 54.2998 0.712415 55.5484 1.40223 55.7491C4.15816 56.5533 8.68009 57.5134 11.1691 58.364C15.4377 59.8682 19.6085 61.6371 23.657 63.6604",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M7.13707 57.2666C6.34942 57.3296 6.2549 57.3296 5.90834 57.3611C1.37149 57.7707 1.78107 59.0011 2.5057 59.157C5.33957 59.7639 9.59618 60.1884 12.2725 60.5747C15.4006 60.7766 18.4805 61.4474 21.4092 62.5646",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M103.587 17.4707C109.391 33.159 106.202 38.5455 95.8047 32.969L99.9005 38.7047",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M59.627 80.3858C63.2501 69.7053 67.8251 55.6603 72.3238 51.533C78.3497 45.9963 85.5894 45.0444 87.3206 44.159C88.7946 43.5389 90.0775 42.5387 91.0383 41.2604C92.663 38.0787 93.4236 34.526 93.2437 30.958",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M99.3545 34.5762C99.449 38.1678 99.769 43.6001 109.373 46.1073C111.159 46.565 112.89 47.2084 114.54 48.0292C124.899 53.2475 134.966 58.6981 145.794 62.7225",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M142.489 61.4214L145.826 52.5186",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M61.9263 82.6546C53.6599 74.56 45.8651 65.9973 38.5805 57.0088C35.346 57.8382 32.3365 59.3766 29.7699 61.5127C27.2034 63.6487 25.1441 66.3289 23.7412 69.3591C28.6545 75.4149 39.8258 89.7334 49.9226 98.3777C60.3245 107.286 70.3384 105.84 74.4972 92.9902L80.1998 74.4962",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M45.8271 94.4376V108.267C45.8276 113.698 47.9853 118.907 51.8257 122.747C55.6662 126.588 60.8748 128.745 66.306 128.746H213.344C216.033 128.747 218.697 128.218 221.182 127.188C223.666 126.159 225.924 124.65 227.825 122.748C229.727 120.847 231.236 118.589 232.265 116.105C233.295 113.62 233.824 110.956 233.823 108.267V24.9671C233.824 22.2776 233.295 19.6143 232.265 17.1295C231.236 14.6447 229.727 12.3872 227.825 10.486C225.924 8.58381 223.666 7.07501 221.181 6.04588C218.697 5.01675 216.033 4.48746 213.344 4.48828H96.6146",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M79.1289 4.48828H66.306C63.6165 4.48763 60.9532 5.01688 58.4683 6.0458C55.9834 7.07473 53.7256 8.58317 51.8238 10.4849C49.922 12.3867 48.4136 14.6445 47.3847 17.1294C46.3558 19.6143 45.8265 22.2776 45.8271 24.9671V65.6097",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M77.3333 93.6729C77.0099 95.3095 72.3371 99.9508 68.3574 106.381",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M63.2175 128.495C62.4232 124.832 62.5973 121.28 63.3634 117.929",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M139.208 128.75C137.933 126.081 136.048 123.75 133.706 121.944C131.363 120.138 128.629 118.908 125.724 118.353L123.963 117.95",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M78.4357 80.2284C78.3518 84.7315 77.9835 89.2248 77.333 93.6814C89.2422 96.8967 99.7967 97.9928 109.564 96.7077C112.051 84.1617 115.681 81.9165 116.901 71.9424L141.258 81.9944C144.345 83.2601 147.79 83.3387 150.931 82.215",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M154.334 25.5029H151.978C150.341 25.5038 148.771 26.1545 147.613 27.312C146.455 28.4695 145.804 30.0392 145.803 31.6764V76.4794C145.804 78.1165 146.456 79.686 147.613 80.8434C148.771 82.0008 150.341 82.6516 151.978 82.6529H154.341",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M215.58 25.5029H154.301C152.663 25.5029 151.093 26.1535 149.935 27.3116C148.777 28.4697 148.126 30.0403 148.126 31.6781V76.4794C148.126 78.1172 148.777 79.6879 149.935 80.8459C151.093 82.004 152.663 82.6546 154.301 82.6546H215.58C217.218 82.6546 218.788 82.004 219.947 80.8459C221.105 79.6879 221.755 78.1172 221.755 76.4794V31.6781C221.755 30.0403 221.105 28.4697 219.947 27.3116C218.788 26.1535 217.218 25.5029 215.58 25.5029Z",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M177.713 82.6572L175.723 101.622C175.645 102.352 175.299 103.027 174.752 103.517C174.205 104.007 173.496 104.277 172.761 104.275H168.162C167.903 104.276 167.646 104.329 167.408 104.43C167.169 104.531 166.953 104.679 166.772 104.864C166.59 105.048 166.446 105.267 166.349 105.508C166.253 105.748 166.205 106.006 166.208 106.265H177.424L180.008 82.6688L177.713 82.6572Z",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M177.427 106.253H195.669L193.4 82.6572H180.01L177.427 106.253Z",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M180.923 55.5589C181.002 56.5295 181.291 57.4714 181.771 58.3188C182.251 59.1662 182.91 59.8988 183.702 60.4654C184.494 61.032 185.4 61.419 186.357 61.5994C187.314 61.7799 188.299 61.7494 189.242 61.5102C190.827 61.1101 192.21 60.145 193.133 58.7963C194.055 57.4477 194.453 55.8085 194.251 54.187C194.05 52.5655 193.263 51.0736 192.039 49.9917C190.814 48.9098 189.236 48.3127 187.603 48.3125C185.757 48.391 184.018 49.1976 182.766 50.5559C181.514 51.9141 180.851 53.7131 180.923 55.5589Z",
    fill: "#3FC8D4",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M183.569 45.2582C184.638 46.059 185.953 46.4603 187.287 46.3924C187.258 45.3856 186.913 44.4135 186.3 43.6136C185.688 42.8137 184.84 42.2265 183.876 41.9351C183.236 41.7407 182.563 41.6819 181.899 41.7627C182.04 43.0843 182.629 44.318 183.569 45.2582Z",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M109.562 96.707C110.255 100.861 112.42 103.89 115.805 106.273",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M157.581 128.748C155.457 124.355 152.151 120.641 148.033 118.022",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M83.6023 45.3545C82.6571 51.7502 100.71 55.1843 100.867 48.5366C105.31 53.483 112.462 50.3606 108.744 45.9216",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M106.161 45.0051C104.9 50.3611 96.9924 49.071 85.9023 44.6602",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M48.252 117.941H231.396",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M233.823 106.271H45.8271",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M28.1514 74.7455C31.8691 68.2238 36.6679 63.9175 42.5496 61.8281",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M127.363 76.2899C120.904 72.5722 117.312 64.1602 117.312 64.1602C117.326 66.76 117.188 69.3583 116.899 71.9421",
    stroke: "#0F172A",
    strokeWidth: 1.66654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4293",
    d: "M93.837 23.969C95.5703 23.1023 95.2815 19.2746 94.9203 17.469C95.2813 17.469 96.6533 17.6861 99.2533 18.5544C101.853 19.4226 103.225 18.1926 103.587 17.469L105.753 21.8044C106.114 21.8044 107.053 20.2877 107.92 14.221C109.003 6.6377 100.337 2.30235 94.9203 1.21901C89.5041 0.135681 89.5033 3.38568 84.0866 4.46901C78.6699 5.55235 77.587 12.0523 75.4203 18.5523C73.2537 25.0523 80.837 27.219 85.1703 31.5523C88.637 35.019 91.6703 32.2746 92.7537 30.469C92.7533 29.3877 93.7251 26.5329 91.6703 27.219C88.4199 28.3044 87.337 22.8827 90.587 22.8857C92.7533 22.8877 91.6703 25.0523 93.837 23.969Z",
    fill: "#3FC8D4",
    stroke: "#0F172A",
    strokeWidth: 1.66833
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallScreen);
export default __webpack_public_path__ + "static/media/small_screen.db82110b476c51d4c8998847dddc0548.svg";
export { ForwardRef as ReactComponent };